import { Button, MenuRoot, MenuTrigger, MenuContent, MenuItem, Portal, MenuPositioner, HStack, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { Languages, ChevronDown } from 'lucide-react'

const LANGUAGES = {
  fr: 'Français',
  en: 'English',
}

export function LanguageSelector() {
  const { i18n } = useTranslation()

  const currentLanguage = LANGUAGES[i18n.language as keyof typeof LANGUAGES] || LANGUAGES.en

  return (
    <MenuRoot positioning={{ placement: 'bottom', sameWidth: true }}>
      <MenuTrigger asChild>
        <Button
          variant="outline"
          size="md"
          borderColor="gray.300"
          color="gray.700"
          _hover={{ bg: 'gray.50', borderColor: 'gray.400' }}
          px={3}
          w="full"
          justifyContent="space-between"
        >
          <HStack gap={2} flex={1}>
            <Languages size={18} />
            <Text fontSize="sm" fontWeight="medium" flex={1}>
              {currentLanguage}
            </Text>
          </HStack>
          <ChevronDown size={16} />
        </Button>
      </MenuTrigger>
      <Portal>
        <MenuPositioner>
          <MenuContent>
            <MenuItem
              value="fr"
              onClick={() => i18n.changeLanguage('fr')}
              bg={i18n.language === 'fr' ? 'brand.50' : 'transparent'}
              color={i18n.language === 'fr' ? 'brand.800' : 'gray.700'}
              fontWeight={i18n.language === 'fr' ? 'semibold' : 'normal'}
              _hover={{ bg: 'gray.50' }}
            >
              Français
            </MenuItem>
            <MenuItem
              value="en"
              onClick={() => i18n.changeLanguage('en')}
              bg={i18n.language === 'en' ? 'brand.50' : 'transparent'}
              color={i18n.language === 'en' ? 'brand.800' : 'gray.700'}
              fontWeight={i18n.language === 'en' ? 'semibold' : 'normal'}
              _hover={{ bg: 'gray.50' }}
            >
              English
            </MenuItem>
          </MenuContent>
        </MenuPositioner>
      </Portal>
    </MenuRoot>
  )
}
